import { ReactComponent as HomeWorkIcon } from '@assets/icons/homework.svg';
import { ReactComponent as ClassesIcon } from '@assets/icons/classes.svg';
import { ReactComponent as StudentsIcon } from '@assets/icons/students.svg';
import { ReactComponent as NotificationIcon } from '@assets/icons/notifications.svg';
import { ReactComponent as SettingsIcon } from '@assets/icons/settings.svg';
import { ReactComponent as DashboardIcon } from '@assets/icons/dashboard.svg';
import { ReactComponent as NoticeboardIcon } from '@assets/icons/noticeboard.svg';
import { ReactComponent as AnnouncementIcon } from '@assets/icons/megaphone.svg';
import { ReactComponent as CalendarIcon } from '@assets/icons/calendar.svg';

import {
  CLASSES,
  HOMEWORK_MANAGEMENT,
  DASHBOARD,
  NOTIFICATIONS,
  SETTINGS,
  STUDENTS,
  NOTICEBOARD,
  CHAT,
  CALENDAR
} from './routes';

const MENU_ITEMS = [
  {
    id: 1,
    Icon: DashboardIcon,
    label: 'Dashboard',
    route: DASHBOARD.DASHBOARD
  },
  {
    id: 2,
    Icon: HomeWorkIcon,
    label: 'Homeworks',
    route: HOMEWORK_MANAGEMENT.HOMEWORKS
  },
  {
    id: 3,
    Icon: NotificationIcon,
    label: 'Notifications',
    route: NOTIFICATIONS.NOTIFICATIONS
  },
  {
    id: 9,
    Icon: CalendarIcon,
    label: 'Calendar',
    route: CALENDAR.CALENDAR
  },
  {
    id: 4,
    Icon: ClassesIcon,
    label: 'Classes',
    route: CLASSES.CLASSES
  },
  {
    id: 5,
    Icon: StudentsIcon,
    label: 'Students',
    route: STUDENTS.STUDENTS
  },
  {
    id: 6,
    Icon: AnnouncementIcon,
    label: 'Announcement',
    route: NOTICEBOARD.NOTICEBOARD
  },
  {
    id: 7,
    Icon: NoticeboardIcon,
    label: 'Chat',
    route: CHAT.CHAT
  },
  {
    id: 8,
    Icon: SettingsIcon,
    label: 'Settings',
    route: SETTINGS.SETTINGS
  }
];

export default MENU_ITEMS;
